export const PROCESS_LIST = 'PROCESS_LIST'; // 流程列表
export const TASK_LIST = 'TASK_LIST'; // 我的任务列表
export const INITIATE_LIST = 'INITIATE_LIST'; // 我的发起列表

